import ContestsGrid from '../components/ContestsGrid';
import { PostProvider, ContestsProvider } from '../store';

export default function ContestsGridLayout() {
  return <PostProvider>
    <ContestsProvider>
      <ContestsGrid />
    </ContestsProvider>
  </PostProvider>;
}
